import CommonState from '@/class/cargo/model/parameters/CommonState'

export const CARGO_CHINESE_NAME = new CommonState(0, '中文品名', 'CARGO_CHINESE_NAME')
export const CARGO_ENGLISH_NAME = new CommonState(1, '英文品名', 'CARGO_ENGLISH_NAME')
export const MARK = new CommonState(2, '唛头', 'MARK')

// 检查字段
export const SENSITIVE_WORD_FIELDS = [
  CARGO_CHINESE_NAME,
  CARGO_ENGLISH_NAME,
  MARK
]
